
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useUser } from '@/contexts/UserContext';

const PERSONAL_MEAL_PLANS_COUNT = 'personal-meal-plans-count';

/**
 * Hook to get count of meal plans created by the current user only
 */
export const usePersonalMealPlans = () => {
  const { user } = useUser();

  return useQuery({
    queryKey: [PERSONAL_MEAL_PLANS_COUNT, user?.id],
    queryFn: async () => {
      if (!user?.id) return 0;
      
      console.log('Fetching personal meal plans for user:', user.id);
      
      // Count meal plans created by the current user only
      const { count, error } = await supabase
        .from('meal_plans')
        .select('*', { count: 'exact', head: true })
        .eq('user_id', user.id);
      
      if (error) {
        console.error('Error fetching personal meal plans count:', error);
        throw error;
      }
      
      console.log('Personal meal plans count:', count);
      return count || 0;
    },
    enabled: !!user,
    staleTime: 0, // Always refetch to ensure fresh data
    gcTime: 0, // Don't cache the data
  });
};
